import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import 'remixicon/fonts/remixicon.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './utils/i18n';

import './index.css';

const loadingSuspense = () => {
  return (
    <div className='center'>
      Loading ...
    </div>
  )
}

ReactDOM.render(
  <Suspense fallback={loadingSuspense()}>
    <React.StrictMode>
        <App />
    </React.StrictMode>
  </Suspense>,

  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
